import axios, { AxiosResponse } from 'axios'
import { cachedRequest } from '../../../../../_metronic/helpers/requestCache'
import { CondicaoCatalogo } from './condicao/catalogo'

const API_URL = process.env.REACT_APP_API_URL

/**
 * Catálogo da linguagem de condição de formulários: variáveis do atendimento, sinais vitais e
 * operadores por tipo. Dado quase-estático e só deste módulo — por isso fica aqui, e não no
 * `crud-helper` do tema (o `_metronic` não deve importar código de negócio).
 * @returns CondicaoCatalogo
 */
export const getCatalogoCondicaoFormulario = (): Promise<CondicaoCatalogo> => {
  return cachedRequest('tipos/formulario/condicao', () =>
    axios
      .get(`${API_URL}/tipos/formulario/condicao`)
      .then((resp: AxiosResponse<CondicaoCatalogo>) => resp.data)
  )
}
